import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M290 818V434l119-68c133-75 123-74 205-14 21 15 48 28 59 28 12 0 51-18 89-41l68-41 52 31c29 17 83 47 120 68l68 38v765H738l-30-31-31-31-23 29-22 28-171 3-171 3zm688 294c9-7 12-78 10-322l-3-313-70-43c-38-24-76-43-84-44-7 0-29 10-48 21l-34 21 28 15c15 8 52 28 81 44l52 30v245c0 134-3 244-6 244s-19-9-34-20c-41-29-111-60-139-60-23 0-23 2-19 69 4 74 21 106 62 114 39 8 191 7 204-1m-354-24c15-25 19-48 17-117l-1-44-36 6c-20 4-63 22-95 41l-59 35V521l58-34c31-18 65-36 76-40 18-7 18-8 1-27-10-11-26-22-36-25-18-6-99 30-151 67l-27 19-3 314-3 315h122c116 0 123-1 137-22m-17-234c59-17 97-15 176 10l47 15V560l-47-24c-27-14-61-34-76-44l-29-20-47 32c-27 17-62 39-80 48l-31 17v157c0 136 2 155 15 150 9-3 41-13 72-22" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(1.0825 0 0 -1.0825 -236.105 1311.328)" /></svg>;
export default Component;
export { Component as ReactComponent };